import React from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import { FieldInput } from "../../../components/FieldInput";
import { FIELDS } from "./CONSTANT";
import { useParams } from "react-router-dom";

export default function LeavesForm({ validation }) {
  const {id: employeeId} = useParams()
  
  const fields = employeeId !== 'noId' ? FIELDS.filter(f => f.key != 'employeeId') : FIELDS

  return (
    <Row>
      <Col md={12}>
        <Card>
          <CardBody>
            <Row>
              {fields.map((f) => (
                <FieldInput key={f.key} f={f} validation={validation} />
              ))}
            </Row>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
}
